<template>
  <div>
    <br>
    <div>
      <legend>Experiencia Laboral</legend>
      <div class="col-12 alert alert-info mb-0">Incorporar al menos los cinco últimos empleos no contando el actual</div>
      <div v-if="add_item">
        <div class="row">
          <div class="col-md-6 form-group">
            <label class="control-label"> Ámbito / sector en el que laboraste </label>
            <br>
            <el-select clearable class="select-default" v-model="modelexp.ambito_id" width="100%" name="ambitoexp" v-validate="'required'" placeholder="Ámbitos">
              <el-option v-for="option in ambitos" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">
              {{ getError('ambitoexp') }}
            </small>
          </div>
        </div>
        <div class="row" v-if="modelexp.ambito_id == 1">
          <div class="col-md-6 form-group">
            <label class="control-label"> Nivel/Orden de Gobierno </label>
            <br>
            <el-select clearable class="select-default" placeholder="Nivel" v-model="modelexp.nivel_gobierno_id">
              <el-option v-for="option in niveles" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4 form-group">
            <label class="control-label"> Ambito público
            </label><br>
            <el-select clearable class="select-default" placeholder="Poder" v-model="modelexp.poder_ente_id">
              <el-option v-for="option in poderes" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 form-group">
            <label class="control-label"> Nombre del ente público / nombre de la empresa, sociedad o asociación </label>
            <input class="form-control" type="text" name="nombreins" v-validate="'required'" v-model="modelexp.nombre_institucion" placeholder="Nombre del ente público / nombre de la empresa, sociedad o asociación" />
            <small class="text-danger">
              {{ getError('nombreins') }}
            </small>
          </div>
          <div class="col-md-3 form-group">
            <label class="control-label"> RFC </label>
            <input class="form-control rfc" type="text" name="rfc" v-validate="'required|max:13'" v-model="modelexp.rfc" placeholder="RFC" />
            <small class="text-danger">
              {{ getError('unidadadm') }}
            </small>
          </div>
          <div class="col-md-3 form-group">
            <label class="control-label">Área de adscripcion/area </label>
            <input class="form-control" type="text" name="unidadadm" v-validate="'required'" v-model="modelexp.unidad_administrativa" placeholder="Área de adscripcion/area" />
            <small class="text-danger">
              {{ getError('unidadadm') }}
            </small>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="control-label"> Empleo, Cargo o comisión/Puesto </label>
              <input class="form-control" type="text" name="cargopuesto" v-validate="'required'" v-model="modelexp.cargo_puesto" placeholder="Cargo/Puesto" />
              <small class="text-danger">
                {{ getError('cargopuesto') }}
              </small>
            </div>
          </div>
          <div class="col-sm-6">
            <label class="control-label"> Especifique funcion principal </label>
            <el-select multiple class="select-default" v-model="model_funciones" name="funcionespp" v-validate="'required'" width="100%" filterable placeholder="Buscar Funciones Principales">
              <el-option v-for="(option,i) in funciones" class="select-default" :value="option.id" :label="option.valor" :key="'fun'+i">
              </el-option>
            </el-select>
            <small class="text-danger">
              {{ getError('funcionespp') }}
            </small>
          </div>

          <div class="col-md-6" v-if="modelexp.funcionesp ==13">
            <div class="form-group">
              <label class="control-label"> Otras funciones: </label>
              <input class="form-control" type="text" name="cargopuesto" v-model="modelexp.otras_funciones" placeholder="Otras funciones" />
            </div>
          </div>

          <div class="col-md-6">
            <label class="control-label"> Sector al que pertenece: </label>
            <el-select clearable class="select-default" placeholder="Sector" name="sectorexp" filterable v-validate="'required'" v-model="modelexp.sector_industria_id">
              <el-option v-for="option in sectores" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">
              {{ getError('sectorexp') }}
            </small>
          </div>
          <div class="col-md-4 form-group" v-if="modelexp.sector_industria_id ==11">
            <label class="control-label"> Otro Sector </label>
            <input class="form-control" type="text" name="otroSector" v-model="modelexp.otro_sector" placeholder="Otro Sector" />
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label"> Fecha de ingreso </label>
              <div class="form-group">
                <!-- <el-date-picker :picker-options="fechaIngresoOptions" name="fechaingreso" type="date" v-model="modelexp.fecha_ingreso" v-validate="'required'" value-format="yyyy-MM-dd" format="dd-MM-yyyy" placeholder="Seleccione fecha"></el-date-picker> -->
                <el-date-picker :picker-options="fechaIngresoOptions" name="fechaingreso" type="date" v-model="modelexp.fecha_ingreso" v-validate="'required'" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha">
                </el-date-picker>
              </div>
              <small class="text-danger">
                {{ getError('fechaingreso') }}
              </small>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="control-label"> Fecha de salida </label>
              <div class="form-group">
                <el-date-picker :picker-options="fechaSalidaOptions" name="fechasalida" type="date" v-model="modelexp.fecha_salida" value-format="dd-MM-yyyy" format="dd-MM-yyyy" placeholder="Seleccione fecha">
                </el-date-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="row">

          <div class=" col-md-12">
            <div class="form-group">
              <label>Aclaraciones y observaciones</label>
              <textarea class="form-control" type="text" name="observaciones" v-model="modelexp.observaciones" placeholder="Aclaraciones y observaciones"></textarea>
            </div>
          </div>
        </div>
        <domicilio v-model="n_domicilio" :vista="false" titulo="/Ubicación del Cargo"></domicilio>
        <br><br>
        <div class="row justify-content-end m-3">
          <button class="btn btn-success" @click.prevent="addItem()">
            <span>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-data-table id="tbl_exp" :headers="headers" :items="list_experiencia" :items-per-page="10" class="elevation-1">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete mr-2" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template slot="empty">
                <h5>No existen registros</h5>
              </template>
              <template v-slot:item.ambito_id="{item}" class="text-right">{{getAmbito(item.ambito_id)}}</template>

              <template v-slot:item.nivel_gobierno_id="{ item }">
                <div>{{getNivel(item.nivel_gobierno_id)}}</div>
              </template>
              <template v-slot:item.poder_ente_id="{ item }">
                <div>{{getPoder(item.poder_ente_id)}}</div>
              </template>
              <template v-slot:item.nombre_institucion="{ item }">
                <div>{{item.nombre_institucion}}</div>
              </template>
              <template v-slot:item.unidad_administrativa="{ item }">
                <div>{{item.unidad_administrativa}}</div>
              </template>
              <template v-slot:item.sector_industria_id="{ item }">
                <div>{{getSector(item.sector_industria_id)}}</div>
              </template>
              <template v-slot:item.jerarquia_rango="{ item }">
                <div>{{item.jerarquia_rango}}</div>
              </template>
              <template v-slot:item.cargo_puesto="{ item }">
                <div>{{item.cargo_puesto}}</div>
              </template>
              <template v-slot:item.fecha_ingreso="{ item }">
                <div>{{item.fecha_ingreso }}</div>
              </template>
              <template v-slot:item.fecha_salida="{ item }">
                <div>{{item.fecha_salida }}</div>
              </template>
              <template v-slot:item.direccion_pais_id="{ item }">
                <div>{{getPais(item.direccion_pais_id)}}</div>
              </template>
              <template v-slot:item.direccion_entidad_federativa_id="{ item }">
                <div>{{getEntidad(item.direccion_entidad_federativa_id)}}</div>
              </template>
              <template v-slot:item.direccion_municipio_id="{ item }">
                <div>{{getMunicipio(item.direccion_municipio_id)}}</div>
              </template>
              <template v-slot:item.direccion_cp="{ item }">
                <div>{{item.direccion_cp}}</div>
              </template>
              <template v-slot:item.direccion_numext="{ item }">
                <div>{{item.direccion_numext}}</div>
              </template>
              <template v-slot:item.direccion_numint="{ item }">
                <div>{{item.direccion_numint}}</div>
              </template>

            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker
  } from 'element-ui'
  import {
    mapFields
  } from 'vee-validate'
  import Domicilio from '../Domicilio.vue'
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      Domicilio
    },

    data() {
      let fechatemp;
      return {
        fechaIngresoOptions: {
          disabledDate(date) {
            return date > new Date()
          }
        },
        fechaSalidaOptions: {
          disabledDate(date) {
            return date > new Date()
          }
        },
        // grupo: null,
        ip_id: null,
        datePicker: '',
        poderes: [],
        niveles: [],
        funcionesArr: [],
        funcionesExpArr: [],
        list_experiencia: [],
        edit_item: false,
        add_item: false,
        entidadFed: null,
        municipios: null,
        localidades: null,
        localidad: null,
        entes: [],
        ambitos: [],
        funciones: [],
        sectores: [],
        model: {},
        modelexp: {},
        model_funciones: [],
        n_domicilio: {},

        modelExp: {
          ambitoexp: {
            required: true
          },
          nombreins: {
            required: true
          },
          unidadadm: {
            required: true
          },
          jerarqexp: {
            required: true
          },
          cargopuesto: {
            required: true
          },
          fecha_ingreso: {
            required: true
          }
        },
        headers: [{
            value: "acciones",
            text: "Acciones",
            align: "center",
            sortable: true
          }, {
            value: "ambito_id",
            text: "Ámbito",
            align: "text-left"
          }, {
            value: "nivel_gobierno_id",
            text: "Nivel",
            align: "text-left"
          }, {
            value: "poder_ente_id",
            text: "Poder Jurídico",
            align: "text-left"
          }, {
            value: "nombre_institucion",
            text: "Nombre",
            align: "text-left"
          }, {
            value: "unidad_administrativa",
            text: "Unidad",
            align: "text-left"
          }, {
            value: "sector_industria_id",
            text: "Sector/Industria",
            align: "text-left"
          }, {
            value: "jerarquia_rango",
            text: "Jerarquia",
            align: "text-left"
          }, {
            value: "cargo_puesto",
            text: "Cargo/Puesto",
            align: "text-left"
          }, {
            value: "fecha_ingreso",
            text: "Fecha Ingreso",
            align: "text-left"
          }, {
            value: "fecha_salida",
            text: "Fecha Salida",
            align: "text-left"
          }, {
            value: "direccion_pais_id",
            text: "País",
            align: "text-left"
          }, {
            value: "direccion_entidad_federativa_id",
            text: "Entidad Federativa",
            align: "text-left"
          }, {
            value: "direccion_municipio_id",
            text: "Municipio",
            align: "text-left"
          },


        ],

      }
    },
    /*created(){
        if(this.modelexp.ambito_id==undefined){
          this.modelexp.ambito_id=1;
        }
        if(this.modelexp.nivel_gobierno_id==undefined){
          this.modelexp.nivel_gobierno_id=2;
        }
    },
    */
    mounted() {
      this.getFunciones();
      // this.grupo = this.getKey('grupo');
      this.ip_id = this.getId();
      this.getSectores();
      this.getPoderes();
      this.getNivelesG();
      this.getAmbitos();
      this.getExperiencia();
      this.getEntes();
      this.$http.get("entidadFed").then(response => {
        this.entidadFed = response.data.entidadfed;
      }, error => {
        this.Err(error);
      });

      this.$http.get("municipios").then(response => {
        this.municipios = response.data.municipios;
      }, error => {
        this.Err(error);
      });
    },
    watch: {
      model_funciones: function (val) {
        this.modelexp.funcionesp = val;
      },
      n_domicilio: {
        handler: function () {
          if (this.n_domicilio) {
            this.modelexp.direccion_pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
            this.modelexp.direccion_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
            this.modelexp.direccion_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
            this.modelexp.direccion_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
            this.modelexp.direccion_vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
            this.modelexp.direccion_vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
            this.modelexp.direccion_numext = this.n_domicilio.ext;
            this.modelexp.direccion_numint = this.n_domicilio.int;
            this.modelexp.direccion_localidad_id = this.n_domicilio.localidad;
            this.modelexp.direccion_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
          }
        },
        deep: true
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        return this.$validator.validateAll()
      },
      showItem() {
        this.add_item = true;
        this.$validator.resume();
      },
      getPais(index) {
        var resp = "México";
        if (this.paises) {
          this.paises.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getMunicipio(index) {
        var resp = "";
        if (this.municipios) {
          this.municipios.forEach(function (item) {
            if (item.id == index) {
              resp = item.nom_mun;
              return resp;
            }
          });
        }
        return resp;
      },
      getAmbito(index) {
        var resp = "";
        if (this.ambitos) {
          this.ambitos.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getPoder(index) {
        var resp = "";
        if (this.poderes) {
          this.poderes.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getNivel(index) {
        var resp = "";
        if (this.niveles) {
          this.niveles.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getSector(index) {
        var resp = "";
        if (this.sectores && index) {
          this.sectores.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getEntidad(index) {
        var resp = " ";
        if (this.entidadFed) {
          this.entidadFed.forEach(function (item) {
            if (item.id == index) {
              resp = item.nom_ent;
              return resp;
            }
          });
        }
        return resp;
      },
      getEnte(index) {
        var resp = " ";
        if (this.entes) {
          this.entes.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      cancelEdit() {
        this.limpiaCampos();
        this.edit_item = false;
        this.add_item = false;
        this.model_funciones = [];
        this.$validator.pause();
      },
      getExperiencia() {
        var v = this;
        this.$http.get('expLaboral/' + this.ip_id).then(response => {
          this.list_experiencia = response.data.experiencia;
        }, error => {
          this.StepError(error);
          // console.log(error);
        })
      },
      getEntes() {
        var v = this;
        this.$http.get('cat_ente_publico').then(response => {
          this.entes = response.data.entes_publicos;
        }, error => {
          this.StepError(error);
          // console.log(error);
        })
      },
      getSafe(fn, defaultVal) {
        try {
          return fn();
        } catch (e) {
          return defaultVal;
        }
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            this.loadButton(this.$refs.btnSave);
            this.$http.put('expLaboral/' + this.ip_id, this.modelexp).then(response => {
              this.StepOk("Guardado");
              //if (this.edit_item === undefined || this.edit_item === null) {
              //console.log(response.data.registro);
              if (!this.edit_item) {
                this.list_experiencia.unshift({
                  ...response.data.registro
                });
              } else {
                let index = this.list_experiencia.map(u => {
                  return u.id;
                }).indexOf(response.data.registro.id);
                this.list_experiencia.splice(index, 1, response.data.registro);
              }

              this.cancelEdit();
              //this.getExperiencia();
              //this.edit_item = false;
            }, error => {
              this.StepError(error);
              //this.change =  true;
            });
          } else {
            this.StepW("Hay campos sin completar");
          }
        });
      },
      editItem(item) {
        this.limpiaCampos();
        this.showItem();
        this.edit_item = true;
        /*
        this.modelexp = {
          ...this.list_experiencia[this.edit_item.index]
        };
        */
        this.modelexp = item;

        var v = this;


        /* $.each(this.modelexp.funciones, function (key, value) {
          v.funcionesExpArr.push(value.funcion_id);
        }) */

        this.model_funciones = this.modelexp.funciones.map(obj => {
          return obj.funcion_id
        });

        // this.modelexp.funcionesp = v.funcionesExpArr;

        this.editDomicilio();

        // this.edit_item.item._rowVariant = "warning";
        $(".main-panel").animate({
          scrollTop: 1300
        }, 500, "swing");
      },
      /*       removeItem(indice) {
              if (this.list_experiencia[indice].id !== null) {
                let item = this.list_experiencia[indice];
                this.Ask("Desea borrar este registro", () => {
                  this.$http.delete("expLaboral/" + item.id).then(response => {
                    /* eventBus.$emit("TramiteDelete", item);
                    this.list_experiencia.splice(indice, 1);
                    this.OK("Registro eliminado");
                  }, error => {
                    this.Err(error);
                  });
                });
              } else {
                this.Ask("Desea borrar este registro", () => {
                  this.list_experiencia.splice(indice, 1);
                });
              }
            }, */
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("expLaboral/" + item.id).then(
              response => {
                let index = this.list_experiencia.map(u => {
                  return u.id;
                }).indexOf(item.id);
                this.list_experiencia.splice(index, 1);
                this.StepOk('Registro eliminado');
              }, error => {
                this.Err(error);
              });
          });
        }
      },
      limpiaCampos() {
        this.funcionesArr = [],
          this.funcionesExpArr = [],
          this.modelexp = {
            ambito_id: '',
            nivel_gobierno_id: '',
            poder_ente_id: '',
            nombre_institucion: '',
            unidad_administrativa: '',
            sector_industria_id: '',
            jerarquia_rango: '',
            cargo_puesto: '',
            fecha_ingreso: '',
            fecha_salida: '',
            funcionesp: [],
            otras_funciones: ''
          };
        this.n_domicilio = {
          pais: 150,
          entidadF: '',
          municipio: '',
          localidad: '',
          cp: '',
          colonia: '',
          vialidad: '',
          vialidad_nombre: '',
          ext: '',
          int: ''
        };
      },
      editDomicilio() {
        var v = this;
        this.n_domicilio = {
          'pais_id': v.modelexp.direccion_pais_id,
          'entidadF': v.modelexp.direccion_entidad_federativa_id,
          'municipio': v.modelexp.direccion_municipio_id,
          'colonia': v.modelexp.direccion_colonia,
          'cp': v.modelexp.direccion_cp,
          'localidad': v.modelexp.direccion_localidad_id,
          'ext': v.modelexp.direccion_numext,
          'int': v.modelexp.direccion_numint,
          'vialidad': v.modelexp.direccion_vialidad_tipo,
          'vialidad_nombre': v.modelexp.direccion_vialidad_nombre
        }
      },
      showInput() {
        this.tags.inputVisible = true
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus()
        })
      },
      handleInputConfirm() {
        let inputValue = this.tags.inputValue
        if (inputValue) {
          this.tags.dynamicTags.push(inputValue)
        }
        this.tags.inputVisible = false
        this.tags.inputValue = ''
      },
      getPoderes() {
        this.$http.get('poderJuridico').then(response => {
          this.poderes = response.data.poderJuridico;
        }, error => {
          this.StepError(error);
          // console.log(error);
        })
      },
      getNivelesG() {
        this.$http.get('nivelGobierno').then(response => {
          this.niveles = response.data.nivelGobierno;
        }, error => {
          this.StepError(error);
          // console.log(error);
        })
      },
      getAmbitos() {
        this.$http.get('ambitos').then(response => {
          this.ambitos = response.data.ambitos;
        }, error => {
          this.StepError(error);
          // console.log(error);
        })
      },
      getSectores() {
        this.$http.get('cat_sector_industria').then(response => {
          this.sectores = response.data.sectores;
        }, error => {
          this.StepError(error);
          // console.log(error);
        })
      },
      getFunciones() {
        this.$http.get('funcPrinc').then(response => {
          this.funciones = response.data.funciones;
        }, error => {
          this.StepError(error);
          // console.log(error);
        })
      }
    }
  }

</script>
<style>
  .rfc {
    text-transform: uppercase !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Personal/ExperienciaLaboral.vue